<template>
  <p
    v-html="data.content"
    ref="content"
    :class="`cm-documentation__content-text cm-documentation__content-text--${data.class || 'default'}`"
  />
</template>

<script>
import htmlToVRouterMixin from "@/utils/mixins/htmlToVRouter";

export default {
  mixins: [htmlToVRouterMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.htmlToVRouter(this.$refs.content);
  }
}
</script>

<style lang="scss">
.cm-documentation__content-text {
  &--default {
    margin: 16px 0;
  }

  &--warning,
  &--success,
  &--danger {
    font-size: $font-size_ssmall;
    padding: 1rem 2rem;
    margin: 1rem 0;

    code {
      background-color: rgba(27, 31, 35, 0.05);
      font-size: 0.85em;
      color: #455b6f;
      padding: 0.25rem 0.5rem;
    }
  }

  &--warning {
    background: #fff7cd;
    border-left: 0.5rem solid #e7c000;
    color: #7c6800;
  }

  &--success {
    background: #f3f5f7;
    border-left: 0.5rem solid #42b983;
    color: #17a31c;
  }

  &--danger {
    background: #ffe6e6;
    border-left: 0.5rem solid #c00;
    color: #ab0000;
  }
}
</style>
